import { Component, Injector, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppComponentBase } from 'src/app/shared/app-component-base';
import { GiftConfirmationService } from '@proxy/gifts';
import { catchError, finalize } from 'rxjs';

@Component({
  selector: 'app-confirm-delivered',
  templateUrl: './confirm-delivered.component.html',
  styleUrls: ['./confirm-delivered.component.scss'],
})
export class ConfirmDeliveredComponent extends AppComponentBase implements OnInit {
  giftId: string;
  codeConfirm: string;
  isLoading = true;
  isSuccess = false;
  errorMessage = '';

  constructor(
    private _router: Router,
    private route: ActivatedRoute,
    private giftConfirmationService: GiftConfirmationService,
    injector: Injector
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.giftId = this.route.snapshot.queryParamMap.get('giftId');
    this.codeConfirm = this.route.snapshot.queryParamMap.get('code-confirm');

    if (this.giftId && this.codeConfirm) {
      this.confirmDelivery();
    }
  }

  private confirmDelivery(): void {
    this.giftConfirmationService
      .confirmDeliveryFromEmail(this.giftId, this.codeConfirm)
      .pipe(
        catchError(err => {
          this.isLoading = false;
          this.errorMessage = err.error?.error?.message || 'ギフトの確認に失敗しました。';
          return null;
        }),
        finalize(() => {
          setTimeout(() => {
            this._router.navigate(['/main/wishlist/creator-view']);
          }, 5000);
        })
      )
      .subscribe(res => {
        if (res) {
          this.isSuccess = true;
        } else {
          this.isSuccess = false;
          this.errorMessage = 'ギフトの確認に失敗しました。';
        }
      });
  }
}
